import { use } from 'react'
import { FavoriteViewsPageActionsContext } from './FavoriteViewsPageActionsContext'

export function useFavoriteViewsPageActionsContext() {
  const context = use(FavoriteViewsPageActionsContext)

  if (!context) {
    throw new Error('useFavoriteViewsPageActionsContext must be used within a FavoriteViewsPageActionsProvider')
  }

  return context
}
